var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_452",
    "data-name": "Ellipse 452",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#d3e4e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotGrey);
export default __webpack_public_path__ + "static/media/DotGrey.40425c60fadf697f8406e7f071d1641f.svg";
export { ForwardRef as ReactComponent };